import { defer, type LoaderFunctionArgs } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getFaqDetail } from "../common/service";

export function taxFaqLoader({ request }: LoaderFunctionArgs) {
  const qaId = new URL(request.url).searchParams.get("qaId") || "";
  return defer({
    coreData: resolveLoaderResult(getFaqDetail({ qaId })),
  });
}
